import { MyAvatar } from "../../../components/MyAvatar/index.js";
import { CustomTFunction, TranslationDictionary } from "../../../../customHooks/useTranslation/types.js";
import { IconBox } from "waapi/waap-ui/components/IconBox/IconBox.js";
import { CardLinear } from "waapi/waap-ui/components/Iconsax/CardLinear.js";
import { ICONSAX_SIZE } from "waapi/waap-ui/components/Iconsax/Iconsax.types.js";
import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";
import { SettingsSecondaryMenuItemProperties, SettingsSecondaryMenuPage } from "./types.js";

// @TODO: Remove the Partial<> and add my documents page
export const getSettingsSecondayMenuItems = ({
    t,
    translations,
    theme,
}: {
    t: CustomTFunction;
    translations: TranslationDictionary;
    theme: ITheme;
}): Partial<Record<SettingsSecondaryMenuPage, SettingsSecondaryMenuItemProperties>> => ({
    [SettingsSecondaryMenuPage.MY_ACCOUNT]: {
        icon: <MyAvatar customSize={{ width: 36, height: 36 }} />,
        label: t(translations.sidebar.route.my_account()),
    },
    [SettingsSecondaryMenuPage.BILLS]: {
        icon: (
            <IconBox backgroundColor={theme.colors.tertiary[100]}>
                <CardLinear size={ICONSAX_SIZE.SMALL} color="white" />
            </IconBox>
        ),
        label: t(translations.sidebar.route.bills()),
    },
});
